/* eslint-disable no-unused-vars */
export const mutations = {
    setTripId(state, payload) {
        state.tripId = payload
    },
    async setTripDetails(state, payload) {
        state.trip = payload
    },
    async setTruckInformation(state, payload) {
        state.truckInformation = payload
    },
    async setTrailerInformation(state, payload) {
        state.trailerInformation = payload
    },
    async setRoutePath(state, payload) {
        state.tripRoutePath = payload
    },
    async setDriverActivity(state, payload) {

        if ( payload == null ) {
            state.driverActivity = processedTimeline
            return false
        }
        else if ( !payload ) return false

        let processedTimeline = []

        Object.keys(payload).forEach((step, index) => {
            processedTimeline.push({
                step: index + 1,
                name: step,
                completed: payload[step] !== "0000-00-00 00:00:00" ? true : false,
                date: payload[step] !== "0000-00-00 00:00:00" ? payload[step] : 'N/A'
            })
        })

        state.driverActivity = processedTimeline
    },
    async setTimeInformation(state, payload) {

    },
    async setRouteInformation(state, payload) {
        
    },
    setSealChanges(state, payload) {
        state.sealChanges = payload
    }
}